module.exports = __webpack_public_path__ + "img/argument-1.91082274.jpg";